
<template>
  <div class="container">
    <a href="#/users">Back</a>
    <h2>User Show - {{model.name}}</h2>
  	<hr>

  </div>
</template>

<!-- // // // //  -->

<script>
export default {
  props: ['model']
}
</script>





// WEBPACK FOOTER //
// src/containers/user_show/components/layout.vue